// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1gKE6","label":"Labeled_label__aW72V","divider":"Labeled_divider__3oL7J"};